exports.FieldDataPoint = [
  {
    id: "id",
    name: "id",
    type: "text",
    value: "",
    label: "Id",
    key: "true",
    length: 12,
  },
  {
    id: "key",
    name: "key",
    type: "text",
    value: "",
    label: "key",
    length: 50,
  },
  {
    id: "fieldDataPointTypeId",
    name: "fieldDataPointTypeId",
    type: "text",
    value: "",
    label: "Field Data Type Id",
    length: 12,
  },

  {
    id: "measurementTypeId",
    name: "measurementTypeId",
    type: "text",
    value: "",
    label: "Measurement Type Id",
    length: 12,
  },
  {
    id: "measurementSourceId",
    name: "measurementSourceId",
    type: "text",
    value: "",
    label: "Measurement Source Id",
    length: 12,
  },
  {
    id: "unitId",
    name: "unitId",
    type: "text",
    value: "",
    label: "Unit",
    length: 3,
  },


  {
    id: "dataURL",
    name: "dataURL",
    type: "text",
    value: "",
    label: "Data URL",
    length: 100,
  },
  {
    id: "localPrinter",
    name: "localPrinter",
    type: "text",
    value: "",
    label: "Local Printer",
  },
  {
    id: "unitId",
    name: "unitId",
    type: "text",
    value: "",
    label: "Unit Id",
    length: 11,
  },
  {
    id: "nameLocalizedText",
    name: "nameLocalizedText",
    type: "text",
    value: "",
    label: "nameLocalizedText",
  },
  {
    id: "createdBy",
    name: "createdBy",
    type: "text",
    label: "Created By",
    displayonly: "true",
    value: " ",
  },
  {
    id: "createdOn",
    name: "createdOn",
    type: "datetime",
    label: "Created On",
    displayonly: "true",
    value: " ",
  },
  {
    id: "modifiedBy",
    name: "modifiedBy",
    type: "text",
    label: "Modified By",
    displayonly: "true",
    value: " ",
  },
  {
    id: "modifiedOn",
    name: "modifiedOn",
    type: "datetime",
    label: "ModifiedOn",
    displayonly: "true",
    value: " ",
  },
  {
    id: "nameResourceKey",
    name: "nameResourceKey",
    type: "text",
    value: "",
    label: "nameResourceKey",
    hide: "true",
    displayonly: "true",
  },
];
